import React, { Component } from 'react';
import autoBind from 'react-autobind/src/autoBind';
import TableHelper from 'src/utils/table-helper';
import { asyncRequest, Entities, TOMCAT_URL } from 'src/common';
import OrganizationTasksTable from 'src/components/admin/schools/components/organization-tasks-table';

class OrganizationCustomerTasksModal extends Component {
    constructor(props) {
        super(props);

        autoBind(this);

        this.tableHelper = new TableHelper();

        this.state = {
            tasks: {
                isFetching: true,
                items: [],
            },
            stats: {
                doneTasksRevenue: 0,
                futureTaskRevenue: 0,
            },
        };
    }

    componentDidMount() {
        const { organization, customer } = this.props;
        const type = organization.identifier.startsWith('SL') ? 'school' : 'association';

        asyncRequest(
            `${TOMCAT_URL}api/${Entities.ORGANIZATIONS.repository}/${organization.id}/findAllTasks?type=${type}&customerId=${customer.id}`,
        )
            .then(response => {
                this.setState({
                    tasks: {
                        ...this.state.tasks, // Preserve existing tasks state
                        isFetching: false,
                        items: response.json, // Create a new array with the new item
                    },
                });
            })
            .catch(error => {
                this.setState({
                    companies: {
                        isFetching: false,
                        error: error.message ? error.message : error,
                        items: [],
                    },
                });
            });
    }

    render() {
        const { organization, t } = this.props;

        if (this.state.tasks.isFetching && this.state.tasks.items.length <= 0) return <></>;
        return (
            <>
                <OrganizationTasksTable tasks={this.state.tasks.items} t={t}></OrganizationTasksTable>
            </>
        );
    }
}

export default OrganizationCustomerTasksModal;
